<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Live Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <DataGrid :context="'LiveCampaignsList'" ref="campaignsList" :columnDefs="campaignsColumnDefs"
                    :rowSelection="'single'"

        :rowData="campaignsRecords" :dataSource="campaignsDataSource" @goToLiveSDDashboard="goToLiveSDDashboard"
        @goToLiveSalesDeveloperDefaultViews="goToLiveSalesDeveloperDefaultViews" @openHTMLDashboard="openHTMLDashboard">
      </DataGrid>
    </vx-card>
    <vs-popup title="Set Default View" :active.sync="showHideEditSDDefaultViewPopup">


      <vs-row vs-w="12">





        <!-- <v-select style="width:100%" v-model="selected_view_for_sd" label="name" :options="sd_view_options"
                name="sd_view" /> -->


        <template v-for="views in sd_view_options">

          <vs-row vs-w="12" class="p-2">

            <vs-radio v-model="selected_default_view" :vs-value="views" class="mr-4" vs-name="selected_default_view">{{
              views.name }}
            </vs-radio>
          </vs-row>


          <!-- <input
                  @click="check($event)"
                    type="checkbox"
                    :value="client_user.uuid"
                    :checked="selected_users_for_edit.includes(client_user.uuid)?'checked':null"
                  />
                  <h6 class="p-1">{{ client_user.full_name }}</h6> -->

        </template>









        <vs-button v-if="sd_view_options.length != 0" class="mt-5"
          @click.prevent="updateSalesDeveloperDefaultViewAction">Submit</vs-button>





      </vs-row>
    </vs-popup>



    <vs-popup fullscreen title="Dashboard" :active.sync="showHideHTMLDashboard">


      <div v-if="sdMeta.updatedAt" class="flex items-center flex-wrap mb-2">
        <span class="text-sm">Last updated {{ formatUtc(sdMeta.updatedAt) }} · all times UTC</span>
        <vs-button
          v-if="sdMeta.refreshable"
          size="small"
          type="border"
          icon="refresh"
          class="ml-3"
          :disabled="sdMeta.refreshing"
          @click="refreshSdDashboard"
        >{{ sdMeta.refreshing ? "Refreshing…" : "Refresh" }}</vs-button>
        <span v-if="sdMeta.note" class="text-sm ml-3">{{ sdMeta.note }}</span>
      </div>
      <iframe :src="dashboardBlobUrl" sandbox="allow-scripts allow-popups" style="width:100%;height:1400px;border:none"></iframe>



    </vs-popup>
  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
      dashboardBlobCache: {},  // ADD THIS
    dashboardHtmlCache: {},   // campaignId -> the SD template HTML, to rebuild after a refresh
    dashboardMetaCache: {},   // campaignId -> { updatedAt, refreshable } for the header line
    sdMeta: { campaignId: null, updatedAt: null, refreshable: false, refreshing: false, note: "" },
    sdDestroyed: false,
    dashboardBlobUrl: '',
    showHideHTMLDashboard: false,
    selected_campaign_id: null,
    selected_default_view: null,
    user_id: null,
    sd_view_options: [],
    showHideEditSDDefaultViewPopup: false,
    sales_developer_id: null,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 100
      },
      {
        headerName: "Campaign",
        field: "campaign_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        flex: 1,
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    DataGrid
  },
  watch: {},
  beforeDestroy() {
  this.sdDestroyed = true;
  Object.values(this.dashboardBlobCache).forEach(url => URL.revokeObjectURL(url));
},
  methods: {
    emptySdMeta(campaignId) {
      return { campaignId: campaignId, updatedAt: null, refreshable: false, refreshing: false, note: "" };
    },
    showSdSnapshot(campaignId, snapshot) {
      // The dashboard gets exactly what it got before: { payload, updated_at, viewer_user_id }.
      const injected = { payload: snapshot.payload, updated_at: snapshot.updated_at, viewer_user_id: snapshot.viewer_user_id };
      const json   = JSON.stringify(injected).replace(/</g, '\\u003c');
      const sOpen  = '<' + 'script>';
      const sClose = '<' + '/' + 'script>';
      const inject = sOpen + 'window.__SD_SNAPSHOT__ = ' + json + ';' + sClose;
      const html = (this.dashboardHtmlCache[campaignId] || '').replace('</head>', inject + '</head>');
      const blobUrl = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
      if (this.dashboardBlobCache[campaignId]) URL.revokeObjectURL(this.dashboardBlobCache[campaignId]);
      this.dashboardBlobCache[campaignId] = blobUrl;
      this.dashboardBlobUrl = blobUrl;
      const meta = this.emptySdMeta(campaignId);
      meta.updatedAt = snapshot.updated_at || null;
      // Refresh only when the figures came from emp-dash and the dashboard is not final.
      meta.refreshable = snapshot.source === "emp-dash" && snapshot.refreshable === true;
      this.dashboardMetaCache[campaignId] = { updatedAt: meta.updatedAt, refreshable: meta.refreshable };
      this.sdMeta = Object.assign({}, this.dashboardMetaCache[campaignId], { campaignId: campaignId, refreshing: false, note: "" });
    },
    async refreshSdDashboard() {
      if (this.sdMeta.refreshing) return;
      const campaignId = this.sdMeta.campaignId;
      const before = this.sdMeta.updatedAt;
      const token = localStorage.getItem("accessToken");
      const base  = this.$base_url + '/api/campaigns';
      this.sdMeta.refreshing = true;
      this.sdMeta.note = "Refreshing… this usually takes under a minute.";
      let res = null;
      try {
        res = await fetch(`${base}/sd-dashboard-refresh/${campaignId}`, { method: 'POST', headers: { Authorization: token } });
      } catch (e) { res = null; }
      if (!res || res.status !== 202) {
        if (res && res.status === 409) {
          this.sdMeta.refreshable = false;
          this.dashboardMetaCache[campaignId].refreshable = false;
          this.sdMeta.note = "This dashboard is final and is not refreshed.";
        } else {
          this.sdMeta.note = "Refresh is temporarily unavailable. The figures shown are unchanged.";
        }
        this.sdMeta.refreshing = false;
        return;
      }
      // Refresh (emp-dash only): normally lands in under 35 s; can legitimately never
      // land (emp-dash keeps the previous figures), so give up after 60 s and say so.
      const started = Date.now();
      while (!this.sdDestroyed && this.sdMeta.campaignId === campaignId && Date.now() - started <= 60000) {
        await new Promise(r => setTimeout(r, 5000));
        if (this.sdDestroyed || this.sdMeta.campaignId !== campaignId) return;
        try {
          const d = await fetch(`${base}/sd-dashboard-data/${campaignId}`, { headers: { Authorization: token } });
          if (d.ok) {
            const snap = await d.json();
            if (snap.updated_at && snap.updated_at !== before) {
              this.showSdSnapshot(campaignId, snap);
              this.sdMeta.note = "Updated.";
              return;
            }
          }
        } catch (e) { /* a failed poll keeps the current figures and keeps waiting */ }
      }
      if (this.sdMeta.campaignId === campaignId) {
        this.sdMeta.refreshing = false;
        this.sdMeta.note = "No newer figures yet. Still showing the figures from " + this.formatUtc(before) + ".";
      }
    },
    formatUtc(iso) {
      if (!iso) return "";
      const t = new Date(iso);
      if (isNaN(t.getTime())) return iso;
      return t.toISOString().slice(0, 16).replace("T", " ") + " UTC";
    },
    async openHTMLDashboard(data) {
      try {
  const campaignId = data.campaign_id;
  if (this.dashboardBlobCache[campaignId]) {
    this.dashboardBlobUrl = this.dashboardBlobCache[campaignId];
    this.sdMeta = Object.assign({}, this.dashboardMetaCache[campaignId] || this.emptySdMeta(campaignId));
    this.showHideHTMLDashboard = true;
    return;
  }
 
  const token = localStorage.getItem("accessToken");
  const base  = this.$base_url + '/api/campaigns';
 
  // Fetch HTML and snapshot in parallel — BOTH carry the auth token.
  const [htmlRes, dataRes] = await Promise.all([
    fetch(`${base}/sd-dashboard/${campaignId}`,      { headers: { Authorization: token } }),
    fetch(`${base}/sd-dashboard-data/${campaignId}`, { headers: { Authorization: token } })
  ]);
  if (!htmlRes.ok) throw new Error(`HTTP ${htmlRes.status} (html)`);
  if (!dataRes.ok) throw new Error(`HTTP ${dataRes.status} (data)`);




const html = await htmlRes.text();
const snapshot = await dataRes.json();   // ONE object: { payload, updated_at, viewer_user_id } (+ source, refreshable from emp-dash)
this.dashboardHtmlCache[campaignId] = html;
this.showSdSnapshot(campaignId, snapshot);
this.showHideHTMLDashboard = true;



} catch (err) {
  console.error("Failed to load HTML dashboard:", err);
  this.$vs.notify({ title: 'Dashboard', text: 'This dashboard is temporarily unavailable. Please try again shortly.', color: 'danger' });
}
  
},
    getSDViewLists() {
      let self = this
      let data = {}
      data.campaign_id = this.selected_campaign_id
      data.sales_developer_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getSDViewLists", data)
        .then(res => {
          if (res) {
            self.sd_view_options = res.data;


            self.sd_view_options.forEach(function (e) {
              if (e.is_default_view) {
                self.selected_default_view = e
              }
            })

            self.showHideEditSDDefaultViewPopup = true

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateSalesDeveloperDefaultViewAction() {


      let self = this

      let data = {}
      data.campaign_id = self.selected_campaign_id
      data.sales_developer_id = self.user_id;
      if (this.selected_default_view) {
        data.selected_default_view_id = this.selected_default_view.id
      }

      if (data.selected_default_view_id) {


        self.$store
          .dispatch(
            'campaignsManagement/updateSalesDeveloperDefaultViewAction',
            data
          )
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                location.reload();

              }
            }
          })
          .catch(err => {
            console.log(err)
          })



      }







    },
    goToLiveSalesDeveloperDefaultViews(data) {
      this.selected_campaign_id = data.campaign_id
      this.getSDViewLists()
    },
   
    sdDashboard() {
      this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    goToLiveSDDashboard(value) {
      this.selected_campaign = value;
      this.selected_campaign_id = value.campaign_id;
      this.sdDashboard();
    },

    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          params.request.sales_developer_id = self.sales_developer_id
          self.$store
            .dispatch(
              "campaignsManagement/getSalesDeveloperLiveCampaignsForGrid",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;




              if (response_data.length != 0) {
                self.$refs.campaignsList.gridApi.hideOverlay();
                params.success({ rowData: response.rows, rowCount: response.lastRow })
              } else {
                self.$refs.campaignsList.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }


            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() { },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    self.sales_developer_id = userInfo["uid"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
